import React, { CSSProperties } from 'react'
import './select.scss';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import { returnLotIcon } from '../../functions';

export enum DisplayMode {
  ValueOnly = 'valueOnly',
  ValueAndLabel = 'valueAndLabel',
  IconOnly = 'iconOnly',
  CertifiedMode = 'certifiedMode',
}
export interface SelectProps {
  itemsArray: Array<{[key: string]: any, icon?: React.ReactNode}>, // Added icon property inside item objects
  value?: string | {name: string, id: number, label: string},
  keyItem: string | number,
  keyDisplay: string,
  error?: boolean,
  width?: string,
  onChange: Function,
  filterOptions: string[],
  style?: CSSProperties,
  size?: 'medium' | 'small',
  border?: string,
  height?: string,
  arrowColor?: string,
  menuItemStyle?: CSSProperties,
  defaultValue?: string,  
  icon?: React.ReactNode, 
  displayMode?: DisplayMode;
  disabled: boolean,
}

const images = require('../../Assets/images/lots/CFA.svg');

const useStyles = makeStyles({
  icon: {
    color: (props: SelectProps) => props.arrowColor,
  },
  iconOpen: {
    color: (props: SelectProps) => props.arrowColor,
  },
});

const SelectNooco = ({ icon,arrowColor, menuItemHoverColor, displayMode, defaultValue, itemsArray, border, height, value, keyItem, keyDisplay, error = false, width, onChange = e => e, style, size, menuItemStyle, ...props}: SelectProps) => {

  const classes = useStyles(props);
  
  const renderValue = (selectedValue: string | {name: string, id: number}) => {
    const selectedItem = typeof selectedValue === 'string' ? itemsArray.find(item => item[keyItem].toLowerCase() === selectedValue.toLowerCase() ) : selectedValue ;

    
    if (!selectedItem && !value) {
      return "";
    }

    if(displayMode === DisplayMode.IconOnly) {
      return <p className="container-lot-icon">{returnLotIcon(selectedItem.name.toLowerCase())}</p>
    }
    if(displayMode === DisplayMode.CertifiedMode) {
      return selectedItem[keyItem].split(' ')[0];
    }
    
  
    if (displayMode === DisplayMode.ValueAndLabel) {
      return selectedItem[keyItem];
    }
  
    return selectedItem[keyDisplay];
  };
  

  return (
    
    <Select
    {...props}
    renderValue={renderValue}
    key={value}
      classes={{
        icon: classes.icon,
        iconOpen: classes.iconOpen,
      }}
      value={value}
      className={`selectUiV1 ${size === 'small' ? 'small' : ""}`}
      style={{
        width: width,
        border: error ? '1px solid red' : border,
        height,
        ...style
      }}
      defaultValue={defaultValue}
      error={error}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ 'aria-label': 'Without label' }}
      variant="outlined"
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        PaperProps: { 
          style: {
            minWidth: '100px' 
          }
        },
      }}
    >
      {
        itemsArray.map(item => {
          return (
            <MenuItem style={menuItemStyle} 
            onMouseEnter={(e) => {
              e.currentTarget.style.background = menuItemHoverColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "initial"; 
            }}
            value={item[keyItem]} key={item[keyItem]}>
              {displayMode === 'iconOnly' && <span style={{ color: 'black' }} className="container-lot-icon icon-in-list">{returnLotIcon(item[keyDisplay].toLowerCase())}</span>}
              {item[keyDisplay]}
            </MenuItem> 
          );
        })
      }
    </Select>
  )
}

export default SelectNooco;
